import script from "./DeliveryOptionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryOptionTabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__